import { logger } from '@fiverr-private/obs';
import { APP_NAME } from '../../../configuration/constants';

enum Severity {
    info = 'info',
    error = 'error',
}

const log = (severity: Severity, error: string, enrichment?: object) => {
    logger[severity](`[${APP_NAME}] ${error}`, { ...enrichment });
};

export const logInfo = (error: string, enrichment?: object) => {
    log(Severity.info, error, enrichment);
};

export const logError = (error: string, enrichment?: object) => {
    log(Severity.error, error, enrichment);
};
